export class UIMessageModel {

    id?: string;
    modifier: string;
    label: string;
    type: number;
    handler?: any

    constructor(source: UIMessageModel) {
        this.id = source.id;
        this.modifier = source.modifier;
        this.label = source.label;
        this.type = source.type;
        this.handler = source.handler;
    }
}